import React, {useState} from 'react';
import {Container, FormControl, InputGroup} from "react-bootstrap";
import {CustomButton, TextInput} from "../components";
import {CalendarIcon, EmailIcon, KeyIcon, MobileIcon} from "../assets";
import NextIcon from "../assets/next-icon";
import {Link} from "react-router-dom";
import {PATH_AUTH} from "../routes/paths";
import useAuth from "../hooks/useAuth";
import useIsMountedRef from "../hooks/useIsMountedRef";
import {useForm} from "react-hook-form";
import {FormProvider} from "../components/hook-form";
import {useNavigate} from "react-router";
import Spiner from "./spiner";
import JalaliDatePicker from "../components/datepicker";


function Register() {

    const {registerMethod} = useAuth();
    const [value, setValue] = useState(new Date());

    const isMountedRef = useIsMountedRef();
    let navigate = useNavigate();


    const methods = useForm();

    const {
        reset,
        register,
        setError,
        handleSubmit,
        formState: {errors, isSubmitting},
    } = methods;
    const months = [
        'فروردین',
        'اردیبهشت',
        'خرداد',
        'تیر',
        'مرداد',
        'شهریور',
        'مهر',
        'آبان',
        'آذر',
        'دی',
        'بهمن',
        'اسفند',
    ]
    const {onChange, onBlur, name, ref} = register('birth_date')
    const onSubmit = async (data) => {

        try {
            await registerMethod(data.mobile, data.password, data.full_name, value.toLocaleDateString("fa-ir",{
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            }));
            navigate(PATH_AUTH.verify, {})
        } catch (error) {
            reset();
            if (isMountedRef.current) {
                setError('mobile', {
                    type: 'server',
                    message: error.message ?? error.errors?.mobile[0]
                })
                if (error.errors?.mobile) {
                    setError('mobile', {
                        type: 'server',
                        message: error.errors.mobile[0],
                    });
                }
                if (error.errors?.password) {
                    setError('password', {
                        type: 'server',
                        message: error.errors.password[0],
                    });
                }
                if (error.errors?.full_name) {
                    setError('full_name', {
                        type: 'server',
                        message: error.errors.full_name[0],
                    });
                }
                if (error.errors?.birth_date) {
                    setError('birth_date', {
                        type: 'server',
                        message: error.errors.birth_date[0],
                    });
                }
            }
        }

    };
    return (
        <div id="register-page">
            {isSubmitting && <Spiner/>}

            <div id="register-header" className="d-flex flex-column justify-content-center align-items-center ">
                <Container>
                    <h1 className="text-white">
                        اندام بــــرتر
                    </h1>
                    <p className="text-white">
                        با راهنمایی های ما اندام موردنظرت رو بساز!
                    </p>
                </Container>
            </div>
            <Container>
                <div>
                    <h2 className="mt-4 page-title">اطلاعات خود را وارد کنید</h2>
                    <p className="page-hint">لطفا فیلدهای زیر را بدقت پر کنید.</p>
                </div>
                <>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <div className="custom-input">
                            <InputGroup>
                                <div className="icon">
                                    <EmailIcon/>
                                </div>
                                <FormControl
                                    placeholder="نام و نام خانوادگی ..." size="lg"
                                    type="text" {...register('full_name')}
                                />

                            </InputGroup>
                            {errors.full_name && <p className="text-danger mb-0">{errors.full_name.message}</p>}

                        </div>
                        <div className="custom-input">

                          <JalaliDatePicker value={value}  onChange={(newValue) => {
                              setValue(newValue);
                          }}/>
                            {errors.birth_date && <p className="text-danger mb-0">{errors.birth_date.message}</p>}
                        </div>

                        <div className="custom-input">
                            <InputGroup>
                                <div className="icon">
                                    <MobileIcon/>
                                </div>
                                <FormControl type="text" placeholder="شماره موبایل ..."
                                             size="lg" {...register('mobile')}/>

                            </InputGroup>
                            {errors.mobile && <p className="text-danger mb-0">{errors.mobile.message}</p>}

                        </div>
                        <div className="custom-input">
                            <InputGroup>
                                <div className="icon">
                                    <KeyIcon/>
                                </div>
                                <FormControl type="password" placeholder="رمز عبور ..."
                                             size="lg" {...register('password')}/>
                            </InputGroup>
                            <p className="text-muted">رمز عبور می بایست حداقل ۶ نویسه باشد</p>
                            {errors.password && <p className="text-danger mb-0">{errors.password.message}</p>}

                        </div>

                        <footer className=" mt-5 mb-3" id="footer-section">
                            <CustomButton>
                                <NextIcon/>
                                <span> مرحله بعدی</span>
                            </CustomButton>
                            <div className="text-center p-2">
                                <span>قبلا عضو شده اید؟</span> <Link to={PATH_AUTH.login}>ورود به حساب</Link>
                            </div>
                        </footer>
                    </FormProvider>
                </>
            </Container>
        </div>
    );
}

export default Register;
